﻿import $ from 'jquery';
import { StringExtensions } from "../utilities/extensions";
import "../utilities/disable";

declare global {
  interface JQuery {
    togglestate: (option: any, args: any) => any;
  }
}

export class ToggleState {
  public static get wireup(): string {
    return this.config.wireup.asDataSelector();
  }
  public static triggerWireup(trigger: string) {
    return this.wireup + this.config.trigger.asAttrSelector(trigger);
  }

  private static config: Config = {
    state: 'data-ts-state',
    command: 'data-ts-command',
    trigger: 'data-ts-trigger',
    wireup: 'togglestate'
  }

  public static toggleAll(key: string): void {
    let $elements = $(this.config.wireup.asDataSelector(key));

    $elements.each(function () {
      let $element = $(this);
      let model = <ToggleState>$(this).data('rustig.togglestate');
      model.toggle();
    });
  }

  public get key(): string {
    return this._key;
  }
  private _key: string;
  private DEFAULTS: ToggleStateOptions = {
    state: undefined,
    command: undefined,
    trigger: undefined
  };

  private $element: JQuery;
  private options: ToggleStateOptions;

  public constructor($element: JQuery, options: ToggleStateOptions) {
    this.$element = $element;
    this.options = $.extend({}, this.DEFAULTS, this.getDataOptions(), options);
    this._key = $element.data(ToggleState.config.wireup);

    this.initAttributes();
  }

  public toggle(): void {
    if (this.$element.isDisabled())
      return;

    let currentState = this.$element.data(ToggleState.config.state);
    if (!currentState)
      return;

    let newState = currentState == 'on' ? 'off' : 'on';
    this.setProperty(ToggleState.config.state, newState);

    this.$element.trigger('toggled.rustig.togglestate');
  }

  private getDataOptions(): ToggleStateOptions {
    return {
      state: this.$element.attr(ToggleState.config.state),
      command: this.$element.attr(ToggleState.config.command),
      trigger: this.$element.attr(ToggleState.config.trigger)
    }
  }

  private initAttributes(): void {
    let state = this.options.state || this.$element.attr(ToggleState.config.state);
    let command = this.validateTriggerEvent(this.options.command) || this.$element.attr(ToggleState.config.command);
    let trigger = this.options.trigger || this.$element.attr(ToggleState.config.trigger);

    this.setProperty(ToggleState.config.state, state);
    this.setProperty(ToggleState.config.command, command);
    this.setProperty(ToggleState.config.trigger, trigger);

    if (command == 'slide') {
      this.$element.addClass('ts-height-peek')
      var maxHeight = this.$element.outerHeight(true);
      this.$element.removeClass('ts-height-peek')
        .css('max-height', maxHeight);
    }

    if (this.options) {
      this.$element.on(this.options.trigger + '.rustig.togglestate', function (e) {
        if (this.$element.isDisabled())
          return;

        let $target = $(e.target);
        let isLink = $target.is('a') && $target.attr('href') != null;
        let isRemote = $target.data('remote') || $target.parent().data('remote');
        let areWeTryingToGoSomewhere = isLink || isRemote;

        if (areWeTryingToGoSomewhere || $target.is('[data-ts-ignore]'))
          return;

        ToggleState.toggleAll(this.key);
      }.bind(this));
    }
  }

  private validateTriggerEvent(event: string): string {
    let validEvents = ['click', 'change'];
    if (event && validEvents.indexOf(event) != -1)
      return event;
    return null;
  }

  private setProperty(property: string, value: any): void {

    if (value === undefined) {
      this.$element.removeAttr(property)
        .removeData(property);
      return;
    }

    this.$element.attr(property, value)
      .data(property, value);
  }
}

export interface ToggleStateOptions {
  state: string,
  command: string,
  trigger: string
};

interface Config extends ToggleStateOptions {
  wireup: string
};

function Plugin(option, args) {
  return this.each(function () {
    let $this = $(this);
    let data = $this.data('rustig.togglestate');
    let options = typeof option == 'object' && option;

    if (!data) {
      data = new ToggleState($this, options);
      $this.data('rustig.togglestate', data);
    }
    if (typeof option == 'string')
      data[option](args);
  });
}

$.fn.togglestate = Plugin;
